// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);"]);
// Module
exports.push([module.id, ".container[data-v-2ea1ef70]{padding-bottom:7.8rem;background:#fff}.LogOutButton[data-v-2ea1ef70]{position:fixed;bottom:0}\n", ""]);
// Exports
module.exports = exports;
